module.exports = __webpack_public_path__ + "img/20210324_212536.4b980cea.jpg";